import FinanceManage from './index';
import System from './Mortgage/system';
import CoinManage from './Mortgage/coinManage';
import Precept from './Mortgage/Precept';
import Account from './Mortgage/account';
import Alarm from './Mortgage/alarmManage';
import OrderDetail from './Mortgage/orderDetail';
import BlastList from './Mortgage/blastList';
import OrderList from './Mortgage/orderList';

import UserSurvey from './superContract/userSurvey';
import PartnerManage from './superContract/partnerManage';
import PartnerManage2 from './superContract/partnerManage2';
import TransactionHold from './superContract/transactionHold';
import TransactionHold2 from './superContract/transactionHold2';
import ProfitStatistic from "./superContract/ProfitStatistic";

export default {
    path: '/home/finance/manage/',
    component: FinanceManage,
    children: [
        {path: '/home/finance/manage/mortgage/system', component: System},
        {path: '/home/finance/manage/mortgage/coin', component: CoinManage},
        {path: '/home/finance/manage/mortgage/precept', component: Precept},
        {path: '/home/finance/manage/mortgage/account', component: Account},
        {path: '/home/finance/manage/mortgage/alarmManage', component: Alarm},
        {path: '/home/finance/manage/mortgage/orderDetail', component: OrderDetail},
        {path: '/home/finance/manage/mortgage/blastList', component: BlastList},
        {path: '/home/finance/manage/mortgage/orderList', component: OrderList},

        {path: '/home/finance/manage/mortgage/userSurvey', component: UserSurvey},
        {path: '/home/finance/manage/mortgage/partnerManage', component: PartnerManage},
        {path: '/home/finance/manage/mortgage/partnerManage2', component: PartnerManage2},
        {path: '/home/finance/manage/mortgage/transactionHold', component: TransactionHold},
        {path: '/home/finance/manage/mortgage/transactionHold2', component: TransactionHold2},
        {path: '/home/finance/manage/general/profit', component: ProfitStatistic}
    ]
}
